<template>
    <div class="socials-wrapper socials-auth">
        <ul class="social-list">
            <!--<li class="social-item">-->
                <!--<a href="#" class="social-link tw" @click.prevent="socialAuth('/auth/social/twitter');"><tw></tw></a>-->
            <!--</li>-->
            <li class="social-item">
                <a href="#" class="social-link fb" @click.prevent="socialAuth('/auth/social/facebook');"><fb></fb></a>
            </li>
            <li class="social-item">
                <a href="#" class="social-link vk" @click.prevent="socialAuth('/auth/social/vkontakte');"><vk></vk></a>
            </li>
        </ul>
    </div>
</template>

<script>
    import tw from '@/assets/svg/tw.svg';
    import fb from '@/assets/svg/fb.svg';
    import vk from '@/assets/svg/vk.svg';
    import Helpers from '@/tools/Helpers'
    export default {
        name: 'Socials',
        components: {
            tw,
            fb,
            vk,
            Helpers
        },
        methods: {
            socialAuth(sn) {
            	Helpers.ga().send('click','Авторизация - ' + sn)
                this.$store.dispatch('socialAuth', sn).then(
                    () => {
                        this.$store.commit('SET_POPUP', false);

                    }
                )
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SocialsAuth.vue?172f4fe8